import { getUserFromToken } from "../Components/Utils";
import Cookies from 'js-cookie';
const hasPermission = (module, permission) => {
    const userDetails = getUserFromToken(Cookies.get('token'));
    const userPermissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
    if (userDetails.role_id === "5f80d631-65dd-4f42-a553-6d78fc3fd4ad" || userDetails.role === "Super Admin" || userDetails.role === "Super Admin User") return true;
    if (!module || !permission) return false;

    const modulePermissions = userPermissions?.[module];

    if (!modulePermissions) return false;

    return Boolean(modulePermissions[permission]);
}


export default hasPermission;